import { render } from "./GeneralPricesDesktop.vue?vue&type=template&id=1344ad75"
import script from "./GeneralPricesDesktop.vue?vue&type=script&lang=js"
export * from "./GeneralPricesDesktop.vue?vue&type=script&lang=js"

import exportComponent from "/opt/approot/build.20250429-113218-4f679910/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__